import { render } from "./HomepageLive.vue?vue&type=template&id=6c0187ca&scoped=true"
import script from "./HomepageLive.vue?vue&type=script&lang=js"
export * from "./HomepageLive.vue?vue&type=script&lang=js"

import "./HomepageLive.vue?vue&type=style&index=0&id=6c0187ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0187ca"]])

export default __exports__